@if (isOpen) {
<div class="fixed inset-0 z-1000 flex items-center justify-center p-4" aria-labelledby="modal-title" role="dialog"
  aria-modal="true">
  <!-- Backdrop -->
  <div class="absolute inset-0 bg-black/50" (click)="onAction('cancel')" aria-hidden="true"></div>

  <!-- Modal Panel -->
  <div class="relative w-full max-w-md overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black/10">
    <div class="px-5 pt-6 pb-4">
      <div class="flex items-start gap-4">

        <div [class]="'flex h-12 w-12 shrink-0 items-center justify-center rounded-full ' + styles.iconBg">

          @if (type === 'danger') {
          <svg [class]="'h-6 w-6 ' + styles.iconColor" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
          </svg>
          }

          @if (type === 'warning') {
          <svg [class]="'h-6 w-6 ' + styles.iconColor" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
          </svg>
          }

          @if (type === 'info') {
          <svg [class]="'h-6 w-6 ' + styles.iconColor" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
          </svg>
          }
        </div>
        <!-- Content -->
        <div class="flex-1">
          <h3 class="text-lg font-semibold leading-6 text-gray-900" id="modal-title">{{ title }}</h3>
          <p class="mt-2 text-sm text-gray-600">{{ message }}</p>
        </div>
      </div>
    </div>
    <!-- Footer -->
    <div class="bg-gray-50 px-5 py-3 flex justify-end gap-3">
      @for (button of buttons; track button.action) {
      <button type="button" (click)="onAction(button.action)" [class]="getButtonClasses(button)">
        {{ button.text }}
      </button>
      }
    </div>
  </div>
</div>
}